"use strict";

document.addEventListener("DOMContentLoaded", () => {
    trainingSummary();
});

const trainingSummary = () => {

    const wrappers = document.querySelectorAll('.training-summary');

    wrappers.forEach(wrapper => {

        const summary = wrapper.querySelector('.summary');
        const moreWrap = wrapper.querySelector('.more');
        const moreBtn = moreWrap ? moreWrap.querySelector('.btn--more') : null;

        let localPage = 1;

        const loadPosts = (isAppend = false) => {

            const formData = new FormData();
            formData.append('action', 'load_moretraining_action');
            formData.append('_wpnonce', scriptObj.nonce);
            formData.append('type', summary.dataset.type);
            formData.append('perPage', summary.dataset.perpage);
            formData.append('pp', localPage);
            formData.append('lang', scriptObj.lang);

            fetch(scriptObj.ajaxurl, { method: 'POST', body: formData })
                .then(res => res.json())
                .then(data => {

                    const hasNewItems = data.data && data.data.trim().length > 0;

                    if (hasNewItems) {

                        if (!isAppend) {
                            summary.innerHTML = '';
                        }

                        summary.insertAdjacentHTML('beforeend', data.data);
                    }

                    if (!hasNewItems || localPage >= data.max) {
                        moreWrap.classList.add('hidden');
                    } else {
                        moreWrap.classList.remove('hidden');
                    }

                })
                .catch(err => console.error(err));
        };

        if (moreBtn) {
            moreBtn.addEventListener('click', e => {
                e.preventDefault();
                localPage++;
                loadPosts(true);
            });
        }

    });

    const cleanText = (text = '') => {
        return text
            .replace(/<br\s*\/?>/gi, ' ')
            .replace(/\n/g,' ')
            .replace(/\u00A0/g,' ')
            .replace(/\s+/g,' ')
            .trim();
    };

    document.addEventListener('click', function(e){

        const btn = e.target.closest('.training-item__link .btn');
        if(!btn) return;

        const contactBlock = document.querySelector('.contact-form');
        if(!contactBlock) return;

        const form = contactBlock.querySelector('form');
        if(!form) return;

        const select = form.querySelector('select[name="your-date"]');
        if(!select) return;

        e.preventDefault();

        const item = btn.closest('.training-item');

        const date = cleanText(
            item.querySelector('.event-date')?.textContent || ''
        );

        const place = cleanText(
            item.querySelector('.event-place')?.textContent || ''
        );

        if(!date || !place) return;

        const targetValue = cleanText(date + ', ' + place);

        contactBlock.scrollIntoView({
            behavior: 'smooth'
        });

        setTimeout(()=>{

            [...select.options].forEach(option => {

                const optionValue = cleanText(option.value);

                if(optionValue === targetValue){
                    select.value = option.value;
                }

            });

            select.dispatchEvent(new Event('change'));

        },400);

    });

};